import CountUp from "react-countup"
import { Link } from "react-router-dom"

import { DashboardState } from "../../../types"

interface Props {
  title: string
  stat: number
  index?: number
  icon: JSX.Element
  linkLabel: string
  linkHref: string
  state?: DashboardState
}

const INDEX_DEFAULT = 0

const DashboardStatCard: React.FC<Props> = ({
  title,
  index = INDEX_DEFAULT,
  stat,
  icon,
  linkLabel,
  linkHref,
  state
}) => {
  return (
    <div className="flex-1 rounded-md bg-white">
      <div className="xl:p-6 p-4 flex items-start">
        <div className="xl:w-16 xl:h-16 w-12 h-12 flex items-center justify-center rounded-full bg-purple-400">
          {icon}
        </div>
        <div className="xl:pl-6 pl-4">
          <div className="text-sm uppercase">{title}</div>
          <div className="text-3xl font-bold">
            <CountUp delay={index * 0.2} end={stat} duration={1} />
          </div>
        </div>
      </div>
      <div className="px-6 py-4 border-t border-gray-300">
        <Link className="text-primary-400 text-sm" to={linkHref} state={state}>
          {linkLabel}
        </Link>
      </div>
    </div>
  )
}

export default DashboardStatCard
